var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8511 4.57357C45.1628 2.51871 46.9292 1 49.0076 1C51.0698 1 52.8275 2.49576 53.1575 4.53138L68.5 99.1818H30.5L44.8511 4.57357Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3878 22.9513C46.6563 22.4686 46.4826 21.8597 46 21.5912C45.8097 21.4854 45.6578 21.2906 45.5273 21.1231C45.3268 20.8659 45.1765 20.673 45.0139 20.9653L1.64003 95.8493L1.28481 96.2444C0.898803 96.6737 0.90608 97.3619 1.30107 97.7815C1.69605 98.2011 2.32918 98.1932 2.71519 97.7638L45.7152 49.9377C46.1012 49.5084 46.0939 48.8202 45.6989 48.4006C45.3039 47.9811 44.6708 47.989 44.2848 48.4183L7.27176 89.5855L46.3878 22.9513Z",
    fill: "#595959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.129 23.6567C51.8548 23.1786 52.0322 22.5754 52.5251 22.3094C52.7962 22.1632 52.8363 21.6962 52.8631 21.3847C52.885 21.1295 52.898 20.9787 53.0215 21.194L98.6392 96.2372L98.7152 96.3184C98.9118 96.5283 99.0064 96.8025 98.9997 97.0744C99.0089 97.425 98.8252 97.7686 98.4924 97.9563C98.3338 98.05 98.1562 98.0948 97.9794 98.091C97.6206 98.091 97.2726 97.9074 97.0858 97.5818L97.056 97.5327L54.2849 51.864C53.8989 51.4519 53.9061 50.7912 54.3011 50.3884C54.6961 49.9856 55.3292 49.9932 55.7152 50.4054L91.8776 89.0176L52.129 23.6567Z",
    fill: "#595959"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMast);
export default __webpack_public_path__ + "static/media/mast.069751f9.svg";
export { ForwardRef as ReactComponent };